import './css/QuotePage.css';

const QuotePage = () => (
  <div className="content quote-page">
    <strong className="quote">
      Mathematics is not about numbers, equations, computations, or algorithms:
      it is about understanding.
      <span className="quote-author no-wrap">&mdash;William Paul Thurston</span>
    </strong>
  </div>
);

export default QuotePage;
